module.exports = __webpack_public_path__ + "first-10_front.jpg?3fab7094efd4db85875f8ed612d8bde4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_front.jpg
// module id = 441
// module chunks = 0